
import { iconSvg } from '~/utils/helpers'
import { getTextFromEvent} from '~/utils/helpers'
import analytics from '~/mixins.js/analytics'

export default {
  mixins: [analytics],
  props: {
    to: String,
    slug: String
  },
  computed: {
    svgIcon () {
      return iconSvg(this.slug)
    }
  },
  methods: {
    trackClick (event) {
      const text = getTextFromEvent(event)
      this.trackEvent('Navigation', text)
    }
  }
}
